import { render, staticRenderFns } from "./fullButton.vue?vue&type=template&id=345254b8&scoped=true&"
import script from "./fullButton.vue?vue&type=script&lang=js&"
export * from "./fullButton.vue?vue&type=script&lang=js&"
import style0 from "./fullButton.vue?vue&type=style&index=0&id=345254b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345254b8",
  null
  
)

export default component.exports